const firstDefined = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "");

export const splitDisplayName = (name = "") => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return { first: "", last: "" };
  if (parts.length === 1) return { first: parts[0], last: "" };
  return { first: parts[0], last: parts.slice(1).join(" ") };
};

// Tenant users store display name in `name`; firstname/lastname on GET can be empty.
export const resolveUserNames = (sourceInput) => {
  const source =
    sourceInput && typeof sourceInput === "object" ? sourceInput : {};
  const username = String(
    firstDefined(source.username, source.userName, "") || ""
  ).trim();
  const rawName = String(source.name || "").trim();
  const iamFirst = String(
    firstDefined(source.firstname, source.firstName, "") || ""
  ).trim();
  const iamLast = String(
    firstDefined(source.lastname, source.lastName, "") || ""
  ).trim();
  const combinedFromIam = [iamFirst, iamLast].filter(Boolean).join(" ").trim();
  const nameIsUsername =
    Boolean(rawName) &&
    Boolean(username) &&
    rawName.toLowerCase() === username.toLowerCase();

  const fromName = nameIsUsername
    ? { first: "", last: "" }
    : splitDisplayName(rawName);

  const nameDiffersFromIam =
    Boolean(rawName) &&
    !nameIsUsername &&
    Boolean(combinedFromIam) &&
    rawName.toLowerCase() !== combinedFromIam.toLowerCase();

  let firstname = "";
  let lastname = "";
  if (nameDiffersFromIam || (!iamFirst && !iamLast && fromName.first)) {
    firstname = fromName.first;
    lastname = fromName.last;
  } else {
    firstname = iamFirst || fromName.first || "";
    lastname = iamLast || fromName.last || "";
  }

  if (!firstname && !lastname) {
    firstname = firstDefined(rawName, username) || "";
  }

  const namesFromIam = Boolean(
    firstDefined(
      source.firstname,
      source.firstName,
      source.lastname,
      source.lastName
    )
  );

  return {
    username: username || firstDefined(rawName, firstname, "") || "",
    displayName:
      [firstname, lastname].filter(Boolean).join(" ").trim() ||
      firstDefined(rawName, username) ||
      "",
    firstname,
    lastname,
    namesFromIam,
  };
};
